// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardMedicationModel {
    static getAttributeTypeMap() {
        return CardMedicationModel.attributeTypeMap;
    }
}
CardMedicationModel.discriminator = undefined;
CardMedicationModel.additionalProperties = false;
CardMedicationModel.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
];
//# sourceMappingURL=cardMedicationModel.js.map